import { useCallback } from 'react';
import { useSelector } from 'react-redux';

/**
 * Custom hook to replace account name placeholder in labels
 * @returns {Object} An object containing:
 *   - replaceAccountName: A memoized function that replaces %s with the actual account name
 */
const useReplaceAccountName = () => {
	const accountName = useSelector((state) => state.accountInfo?.name) || '';

	const replaceAccountName = useCallback(
		(label) => {
			if (typeof label !== 'string') return label;
			return label.replace(/%s/g, accountName);
		},
		[accountName]
	);

	return { replaceAccountName };
};

export default useReplaceAccountName;
